import { handlerHttp } from '../utils/handlerHttp'

const http = handlerHttp()

export const API = {
  getApprovedUsers: () => {
    return http.get('/users/get-approved-users')
  },

  getPendingUsers: ()=>{
    return http.get('/users/get-pending-users')
  },

  getRejectedUsers: ()=>{
    return http.get('/users/get-rejected-users')
  },

  getLastSubscribers: ()=>{
    return http.get('/subscribers/get-last-subscribers')
  },

  getAllProducts:()=>{
    return http.get('/products/get-all-products')
  },

  getPendingComments: ()=>{
    return http.get('/comments/get-pending-comments')
  },

  putUpdateCommentStatus: (commentId, status)=>{
    return http.put('/comments/update-comment-status',{
      body:{
        commentId,
        status
      }
    })
  },

  getStaffUsersList: ()=>{
    return http.get('/staffusers/get-staff-users-list');
  },

  putRemoveStaffUser: (id)=>{
    return http.put('/staffusers/remove-staff-user',{
      body:{
        staffUserId: id
      }
    });
  },

  putUserById: (id) =>{
    return http.put('/users/get-user-by-id', {body:{userId: id}})
  },

  postChangePasswordStaffUser: (body)=>{
    return http.post('/staffusers/change-password-staff-user', {body});
  },

  putUserApprovalSatate: (body) =>{
    return http.put('/users/update-user-approval-state', {body})
  },
  
  postRegisterStaffUserSession: (email, password)=>{
    return http.post('/staffusers/register-staff-user-session',{
      body:{
        email,
        password
      }
    })
  },

  postRegisterUser: (body)=>{
    return http.post('/users/register-user',{
      body
    })
  },

  putVerifyIfEmailExists: (email)=>{
    return http.put('/users/verify-if-email-exists',{
      body:{
        email
      }
    })
  },

  postRegisterUserSession: (email, password)=>{
    return http.post('/users/register-user-session',{
      body:{
        email,
        password
      }
    })
  },  
  
  putUpdateUserData: (body)=>{
    return http.put('/users/update-user-data', {body})
  },

  putUserBySessionKey: (sessionKey)=>{
    return http.put('/users/get-user-by-session-key', {body:{
      sessionKey
    }})
  },

  postRegisterStaffUser: (email, name)=>{
    return http.post('/staffusers/register-staff-user',{
      body:{
        email,
        name
      }
    })
  },
  
  putProductsForUserInSession: (sessionKey)=>{
    return http.put('/products/get-products-for-user-in-session',{
      body:{
        sessionKey
      }
    })
  },

  postRegisterProductForUserInSession:(body)=>{
    return http.post('/products/register-product-for-user-in-session',{
      body
    });
  },

  postUploadFile: (file)=>{
    const formData = new FormData();
    formData.append('file',file);
    return http.postForm('/uploads/',formData);
  },

  getVisitsCount: ()=>{
    return http.get('/visits/count');
  },

  postRegisterVisit: ()=>{
    return http.post('/visits/register-visit')
  },

  putLastProducts: (regionKey,pageNumber,pageSize)=>{
    return http.put('/products/get-last-products',{
      body:{
        regionKey,
        pageNumber,
        pageSize
      }
    })
  },

  putRemoveProductForUserInSession: ({sessionKey, productId})=>{
    return http.put('/products/remove-product-for-user-in-session',{
      body:{
        sessionKey,
        productId
      }
    })
  },

  putChangePasswordUser: ({sessionKey, newPassword})=>{
    return http.put('/usercredentials/change-password',{
      body:{
        sessionKey,
        newPassword
      }
    })
  },

  getLastComments: ()=>{
    return http.get('/comments/get-last-comments');
  },

  postRegisterComment: (body)=>{
    return http.post('/comments/register-comment',{body});
  },

  postRegisterSuscriber: (body)=>{
    return http.post('/subscribers/register-subscriber',{body})
  },

  putForgotPasswordUser: (email)=>{
    return http.put('/users/forgot-password', {
      body:{
        email
      }
    })
  },

  putForgotPasswordStaffUser: (email)=>{
    return http.put('/staffusers/forgot-password', {
      body:{
        email
      }
    })
  },

}